import { ApiRequest } from '../instance';

export type UsvString = string | number | boolean;
// TODO: remove null/undefined from the type
export type AllowedFormData = UsvString | null | undefined | Blob | UsvString[];

const USV_TYPES = ['string', 'number', 'boolean'];
const isUsvString = (value: any): value is UsvString => {
  const valueType = typeof value;

  return USV_TYPES.includes(valueType);
};

export const createFormData = (postData: FormData | Record<string, AllowedFormData>): FormData => {
  if (postData instanceof FormData) {
    return postData;
  }

  const formData = new FormData();

  Object.entries(postData).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((arrayValue) => formData.append(key, arrayValue.toString()));
    } else if (isUsvString(value)) {
      // `append` here creates a string version of the value anyway
      // calling it explicitly satisfies the TS compiler
      formData.append(key, value.toString());
    } else if (value) {
      // value is a Blob, so append it (Blob.toString does not work)
      formData.append(key, value);
    }
  });

  return formData;
};

export const ensureFormHeader = (config: ApiRequest = {}): ApiRequest => ({
  ...config,
  headers: {
    'content-type': 'multipart/form-data',
    ...config.headers,
  },
});
